import "babel-polyfill";

import SwHic, { Vue, App } from "sw-hic";
import "sw-hic/sw-hic.css";
import masterdata from "../packages/masterdata";
import store from "@/common/store";
import router from "@/common/router";
// import regretButton from "@/components/_com/regretButton";
Vue.use(SwHic);
Vue.use(masterdata);
Vue.config.productionTip = false;
if (process.env.NODE_ENV == "development") {
  // 引入mockjs
  // require('./common/mock.js')
}
// Vue.component("regret-button", regretButton);

new Vue({
  render: (h) => h(App),
  router,
  store,
}).$mount("#app");
